// @flow
import type {Element} from 'react'/* eslint-disable no-underscore-dangle */
import React from 'react'
import {sanitize} from 'dompurify'

type Props = {
  htmlDiff: string,
}

function DiffComponent({htmlDiff}: Props): Element<"div"> {
  /* eslint react/no-danger: 0 */
  const renderFormattedDiff = () => (
    <span
      dangerouslySetInnerHTML={{__html: sanitize(htmlDiff)}}
    />
  )

  return (
    <div>
      <div
        className="proposal-diff-component proposal-diff-component__after proposal-diff-component--multi-line"
      >
        {renderFormattedDiff()}
      </div>
    </div>
  )
}

export default DiffComponent
